import {
  saveData,
  delData
} from '@/api/local_storage'

const state = {
  groups_num: 10,
  max_customers_num: 15,
  group_time_limit: 30,
  group_mip_gap: 0.01,
  route_time_limit: 30,
  route_mip_gap: 0.01,
  solution_day: null,
  solution_way: 0,
  parm: [['群组数', 10], ['每个群组最大客户数', 15], ['分配群组模型的TimeLimit', 30], ['分配群组模型的MIPGap', 0.01], ['分配路线模型的TimeLimit', 30], ['分配路线模型的MIPGap', 0.01]],
  solution_weeks: ['星期天', '星期一', '星期二', '星期三', '星期四'],
  solution_ways: ['cbc', 'gurobi']
}

const getters = {
  parm: state => state.parm,
  groupsNum: state => state.groups_num,
  maxCustomersNum: state => state.max_customers_num,
  groupTimeLimit: state => state.group_time_limit,
  groupMipGap: state => state.group_mip_gap,
  routeTimeLimit: state => state.route_time_limit,
  routeMipGap: state => state.route_mip_gap,
  solutionDay: state => state.solution_day,
  solutionWay: state => state.solution_way,
  solutionWeeks: state => state.solution_weeks,
  solutionWays: state => state.solution_ways
}

const actions = {
  initParmData ({ commit, dispatch }, data) {
    let parm = data === 'clear' ? {} : data
    dispatch('setGroupsNum', parm.groups_num || 10)
    dispatch('setMaxCustomersNum', parm.max_customers_num || 15)
    dispatch('setGroupTimeLimit', parm.group_time_limit || 30)
    dispatch('setGroupMipGap', parm.group_mip_gap || 0.01)
    dispatch('setRouteTimeLimit', parm.route_time_limit || 30)
    dispatch('setRouteMipGap', parm.route_mip_gap || 0.01)
    dispatch('setSolutionDay', parm.solution_day || null)
    dispatch('setSolutionWay', parm.solution_way || 0)
  },
  saveParmData ({ commit }, data) {
    commit('saveParmData', data)
  },
  clearParmData ({ commit }, data) {
    delData('parm_data' + data)
  },
  setGroupsNum ({ commit }, data) {
    commit('changeGroupsNum', data)
  },
  setMaxCustomersNum ({ commit }, data) {
    commit('changeMaxCustomersNum', data)
  },
  setGroupTimeLimit ({ commit }, data) {
    commit('changeGroupTimeLimit', data)
  },
  setGroupMipGap ({ commit }, data) {
    commit('changeGroupMipGap', data)
  },
  setRouteTimeLimit ({ commit }, data) {
    commit('changeRouteTimeLimit', data)
  },
  setRouteMipGap ({ commit }, data) {
    commit('changeRouteMipGap', data)
  },
  setSolutionDay ({ commit, dispatch }, data) {
    commit('changeSolutionDay', data)
    dispatch('selectMapDataCustomer', data)
  },
  setSolutionWay ({ commit }, data) {
    commit('changeSolutionWay', data)
  }
}

const mutations = {
  saveParmData (state, data) {
    saveData({key: 'parm_data' + data, data: state})
  },
  changeGroupsNum (state, data) {
    state.groups_num = data
    state.parm[0][1] = data
  },
  changeMaxCustomersNum (state, data) {
    state.max_customers_num = data
    state.parm[1][1] = data
  },
  changeGroupTimeLimit (state, data) {
    state.group_time_limit = data
    state.parm[2][1] = data
  },
  changeGroupMipGap (state, data) {
    state.group_mip_gap = data
    state.parm[3][1] = data
  },
  changeRouteTimeLimit (state, data) {
    state.route_time_limit = data
    state.parm[4][1] = data
  },
  changeRouteMipGap (state, data) {
    state.route_mip_gap = data
    state.parm[5][1] = data
  },
  changeSolutionDay (state, data) {
    state.solution_day = data
  },
  changeSolutionWay (state, data) {
    state.solution_way = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/parm.js